import {toUnixSec, getStartOfDay} from '../../../library/dates';
import {TEticketData} from '../../../redux/eTicket/eTicket.type';

export type EntranceState = 'countdown' | 'today' | 'tomorrow';

const DAY_SEC = 24 * 60 * 60;

export interface EntranceStatusInfo {
    state: EntranceState | null;
    startSec: number | null;
}

export function getEntranceStatus(data: TEticketData | null, now: number): EntranceStatusInfo {
    const startSec = data?.event?.timeStart != null ? toUnixSec(data.event.timeStart) : NaN;
    if(startSec == null || Number.isNaN(startSec))
        return {state: null, startSec: null};

    const dayDiff = Math.round((getStartOfDay(startSec) - getStartOfDay(now)) / DAY_SEC);

    // Currently showing only "today"/"tomorrow". Countdown temporarily disabled — to restore, bring back the line below:
    // const state: EntranceState = dayDiff === 0 ? 'today' : dayDiff === 1 ? 'tomorrow' : 'countdown';
    const state: EntranceState | null = dayDiff === 0 ? 'today' : dayDiff === 1 ? 'tomorrow' : null;
    if(!state)
        return {state: null, startSec: null};

    return {state, startSec};
}
